// Login contract fixture (US-882 · R-6) — registered through the US-883
// fixtures mechanism (fixtures/apiFixtures.js).
//
// Mirrors the backend LoginView (backend/map_stats/views.py): 200
// { ok, username } on valid credentials, 401 { error } otherwise. In fixtures
// mode (static demo on Cloudflare Pages — no backend) the demo-gate semantics
// live HERE instead of inside useAuth: the expected pair comes from
// REACT_APP_DEMO_USERNAME / REACT_APP_DEMO_PASSWORD (build-time env, kept out
// of git — AGENTS.md §4). With no pair configured the gate falls through, so
// local dev and tests are never blocked by a missing secret.
import { registerFixture } from "./apiFixtures";
import { ApiError } from "../api/errors";

registerFixture("login", (body = {}) => {
  const expectedUser = process.env.REACT_APP_DEMO_USERNAME;
  const expectedPass = process.env.REACT_APP_DEMO_PASSWORD;
  const gateConfigured = Boolean(expectedUser && expectedPass);
  // The backend trims the username (LoginView) — mirror that.
  const username = (body.username ?? "").trim();

  const ok =
    !gateConfigured ||
    (username === expectedUser && (body.password ?? "") === expectedPass);

  if (!ok) {
    // Mirror the backend's 401 shape (LoginView: {error}).
    throw new ApiError({
      status: 401,
      message: "Request to /auth/login/ failed with status 401",
      detail: "Invalid username or password",
      path: "/auth/login/",
    });
  }
  return { ok: true, username: username || "demo" };
});
